// Footer.jsx (CSS Modules)
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import s from './Footer.module.css' // <-- подключаем модуль

export const Footer = () => {
  const { t } = useTranslation()
  const year = new Date().getFullYear()

  return (
    <footer className={s.footer}>
      <div className={s['footer__links']}>
        <ul className={s['footer__col']}>
          <li><Link to="/aboutUs">{t('about-us')}</Link></li>
          <li><Link to="/Ethics-Compliance">{t('ethics-compliance')}</Link></li>
          <li><Link to="/Relationship-based">{t('relationship-based')}</Link></li>
          <li><Link to="/CodeOfConduct">{t('code-of-conduct')}</Link></li>
        </ul>

        <ul className={s['footer__col']}>
          <li><Link to="/Recruitment">{t('recruitment')}</Link></li>
          <li><Link to="/StaffingManagement">{t('staffing-management')}</Link></li>
          <li><Link to="/360Hiring">{t('360hiring')}</Link></li>
          <li><Link to="/HrConsultancy">{t('hr-consultancy')}</Link></li>
        </ul>

        <ul className={s['footer__col']}>
          <li><Link to="/Solutions">{t('solutions')}</Link></li>
          <li><Link to="/Network">{t('network')}</Link></li>
          <li><Link to="/Locations">{t('locations')}</Link></li>
          <li><Link to="/Services">{t('our-services')}</Link></li>
        </ul>
				<p className={s['footer__bottom']}>
        © 2018 - {year} Avrasya Consulting. {t('rights')}
      </p>
      </div>

      
    </footer>
  )
}
